export default "__VITE_ASSET__6bca64c3__"